import React from "react";
import {authHeader} from "../../../helpers/authHeader";
import {makeApiUrl} from "../../../helpers/makeApiUrl";
import {handleResponse} from "../../../helpers/handleResponse";
import {Spinner} from "../../Spinner";
import Product from "../Product";
import {requestOption} from "../../../helpers/requestOption";
import Link from "../Link";

class FavoriteProducts extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            queries: [],
            loading: true,
        };
    }

    componentDidMount() {
        fetch(makeApiUrl('favorite-products/last'), requestOption())
            .then(handleResponse)
            .then(response => {
                this.setState({
                    products: response.products,
                    loading: false,
                })
            });
    }

    render() {
        let items;

        if (this.state.loading) {
            items = <Spinner />;
        } else if (this.state.products.length) {
            items = this.state.products.map((product, index) =>
                <Product id={product.goods_id} name={product.goods_name} imageId={product.img_id} key={index} />
            );

            items.push(<Link to="/favorite-products" key="link" className="btn btn-primary btn-block">Pokaż wszystkie ulubione produkty</Link>);
        } else {
            items = 'Brak.';
        }

        return <div className="box">
            <div className="header">
                <h3>Ulubione produkty</h3>
            </div>
            <div className="content">
                {items}
            </div>
        </div>
    }
}

export default FavoriteProducts;
